import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Seo from '../components/Seo';
import { townLandingByPath } from '../data/townLandings';
import { webPageJsonLd } from '../data/pageSchema';
import NotFoundPage from './NotFoundPage';
import './TownLandingPage.css';

const TownLandingPage = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const town = townLandingByPath(pathname);

  if (!town) return <NotFoundPage />;

  const postTo = !user
    ? '/signup'
    : user.type === 'provider'
      ? '/provider-dashboard'
      : '/customer-dashboard';

  return (
    <div className="town-land">
      <Seo
        title={town.title}
        description={town.description}
        path={town.path}
        jsonLd={webPageJsonLd(town)}
      />
      <header className="town-land-hero">
        <div className="hero-bg-lines" aria-hidden="true" />
        <div className="town-land-hero-content">
          <div className="hero-eyebrow">{town.name}, South Wales</div>
          <h1>{town.h1}</h1>
        </div>
      </header>
      <article className="town-land-body">
        <p>{town.purpose}</p>
        <h2>How posting a job works</h2>
        <p>{town.how}</p>
        <p>{town.pay}</p>
        <p>{town.scrap}</p>
        <p>{town.carriers}</p>
        <p>{town.nearby}</p>
        <div className="town-land-actions">
          <Link to={postTo} className="btn btn-primary">Post a job</Link>
          <Link to="/how-it-works" className="town-land-how">See how a job works</Link>
        </div>
      </article>
    </div>
  );
};

export default TownLandingPage;
